import { stripMarkdown } from "../../../Utilities/StripMarkdown";
import TextYScroller from "./textYScroller";

// Define component props with TypeScript
interface ResumeViewProps {
	resume: string | undefined;
	className?: string;
	tailClassMinHeight?: string;
	tailClassMaxHeight: string;
}

// ResumeView Component
const ResumeView: React.FC<ResumeViewProps> = ({
	resume,
	className = "",
	tailClassMinHeight = "min-h-0",
	tailClassMaxHeight
}) => {
	return (
		<div className="border rounded-3xl pt-4 pl-4 pb-4 pr-1">
			<div className="w-auto font-bold text-primary">Resume</div>
			<TextYScroller
				tailClassMinHeight={tailClassMinHeight}
				tailClassMaxHeight={tailClassMaxHeight}
			>
				<pre className="whitespace-pre-wrap text-primary font-sans">
					{stripMarkdown(resume ?? "")}
				</pre>
			</TextYScroller>
		</div>
	);
};

export default ResumeView;
